import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePermit } from "../../services/permits";

import useToast from "../useToast";

import { IWorkerImmigrationDocs } from "../../interfaces/services";
import { IPermit } from "../../interfaces/entities";

export interface IPayload {
    foreignWorkerId: number;
    payload: {
        permitId: number;
    };
    setIsProcessing: Function;
    onSuccess: (permits: IPermit[]) => void;
};

export interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useDeletePermit = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        return await deletePermit(data.payload.permitId);
    };

    return useMutation({
        mutationFn,
        onSuccess: async (response: IResponse, variables: IPayload) => {
            if (response) {
                addToast({
                    type: 'success',
                    title: 'Permit deleted successfully.',
                });

                await queryClient.invalidateQueries({ queryKey: ['foreign_worker_immigration_docs'] });
                const newData: IWorkerImmigrationDocs | undefined = queryClient.getQueryData(['foreign_worker_immigration_docs', variables.foreignWorkerId]);
                variables.onSuccess(newData?.permits ?? []);
            };
        },
        onError: (error: IResponse, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error.message
            });
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useDeletePermit;